type Bezier = [number, number, number, number];
const slowdown:   Bezier = [0, 0, 0.2, 1];
const natural:    Bezier = [0.4, 0, 0.2, 1];
const accelerate: Bezier = [0.4, 0, 1, 1];

// growIn 0–400ms (scale+opacity) + slide from right (dynamic, bar-relative) at 400–900ms; exit: slide right + fade
export const image = {
  visible: {
    scale: 1, opacity: 1, x: 0,
    transition: {
      scale:   { duration: 0.4, ease: slowdown },
      opacity: { duration: 0.4, ease: slowdown },
      x:       { duration: 0.5, delay: 0.4, ease: natural },
    },
  },
  hidden: (hiddenX: number) => ({
    scale: 0.5, opacity: 0, x: hiddenX,
    transition: { duration: 0 },
  }),
  exiting: {
    scale: 0.5, opacity: 0, x: 72,
    transition: {
      x:       { duration: 0.2, ease: accelerate },
      opacity: { duration: 0.15, delay: 0.1, ease: 'linear' as const },
      scale:   { duration: 0.15, delay: 0.1, ease: accelerate },
    },
  },
};

// container: stagger words left-to-right on enter; stagger = 0.158/(n-1) so last word finishes with CTA at 1278ms; exit: fade all words together
export const textContainer = {
  visible: (wordCount: number) => ({
    opacity: 1,
    transition: {
      delayChildren: 0.72,
      staggerChildren: wordCount > 1 ? 0.158 / (wordCount - 1) : 0,
    },
  }),
  hidden: {
    opacity: 1,
    transition: { duration: 0 },
  },
  exiting: {
    opacity: 0,
    transition: {
      opacity: { duration: 0.12, ease: 'linear' as const },
    },
  },
};

// per-word: slide up through overflow:hidden mask; no individual exit (parent fades)
export const textWord = {
  visible: {
    y: 0,
    transition: { duration: 0.4, ease: slowdown },
  },
  hidden: {
    y: '100%',
    transition: { duration: 0 },
  },
  exiting: {
    y: 0,
    transition: { duration: 0 },
  },
};

// slideIn from right 18px at 720ms; exit: reverse entrance (slide right + fade)
export const cta = {
  visible: {
    opacity: 1, x: 0,
    transition: { duration: 0.558, delay: 0.72, ease: slowdown },
  },
  hidden: {
    opacity: 0, x: 18,
    transition: { duration: 0 },
  },
  exiting: {
    opacity: 0, x: 18,
    transition: {
      x:       { duration: 0.2, ease: accelerate },
      opacity: { duration: 0.15, delay: 0.1, ease: 'linear' as const },
    },
  },
};

// circle (bar-height wide) fades in at right, expands leftward into full pill at 400–900ms; exit: slide right + fade
export const background = {
  visible: {
    width: '100%', opacity: 1, x: 0,
    transition: {
      opacity: { duration: 0.4, ease: slowdown },
      width:   { duration: 0.5, delay: 0.4, ease: natural },
      x:       { duration: 0 },
    },
  },
  hidden: (circleSize: number) => ({
    width: circleSize, opacity: 0, x: 0,
    transition: { duration: 0 },
  }),
  exiting: {
    width: '100%', opacity: 0, x: 72,
    transition: {
      x:       { duration: 0.2, ease: accelerate },
      opacity: { duration: 0.15, delay: 0.1, ease: 'linear' as const },
      width:   { duration: 0 },
    },
  },
};
